import { useState, useEffect } from 'react'
import { Search, Button } from 'carbon-components-react'
import { toaster } from '../../helpers/toaster';
import LinksGrid from './LinksGrid'
import LinkDetailModal from './LinksDetailModal'
import ConfirmModal from '../../components/Modal/ConfirmModal'
// api
import {
  addLink,
  updateLink,
  deleteLink,
} from '../../api/links'

const useLinksGrid = ({
  isStudyDetail,
  linkList,
  setStudyDetails,
  studyPgId,
  studyOrgStudyId,
  studyListOptions,
} = {}) => {
  // const [linkList, setLinkList] = useState([])
  const [linkId, setLinkId] = useState(null)
  const [search, setSearch] = useState("")
  const [searchGrid, setSearchGrid] = useState("")
  const [refreshData, setRefreshData] = useState(false)
  const [sort, setSort] = useState("")
  const onlyAttachment = localStorage.getItem('only_attachment')
  // loading is for initial component preloading
  const [linksLoading, setLinksLoading] = useState(false)
  // update modal params
  const [detailModalMode, setDetailModalMode] = useState("")
  const [openLinkModal, setOpenLinkModal] = useState(false)
  const [linkData, setLinkData] = useState(null)
  // delete modal params
  const [openDeleteModal, setOpenDeleteModal] = useState("")
  const [deleteItem, setDeleteItem] = useState(null)

  const addLinkBtnStyle = {
    padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px"
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearchGrid(search)
    }, 500)
    // if this effect run again, because `value` changed, we remove the previous timeout
    return () => clearTimeout(timeout)
  }, [search])

  const addNewLink = () => {
    setDetailModalMode("create")
    setLinkData(null)
    setOpenLinkModal(true)
  }

  const linkRemoveRow = (itemId) => {
    setOpenDeleteModal(true)
    setDeleteItem(itemId)
  }

  const confirmSave = (formData) => {
    setLinksLoading(true);
    if(formData.get('url') === 'undefined' || formData.get('url') === undefined){
      formData.append('url', '')
    }
    return addLink(formData).then(res => {
      // for grid on study details page
      if (linkList && setStudyDetails && res.data) {
        setStudyDetails({
          type: 'ADD_ITEM',
          itemType: 'links',
          item: res.data,
        })
      }

      // for link list page
      setRefreshData(true)
      toaster("Link added successfully", "success")
      setLinksLoading(false);
      setOpenLinkModal(false);
      return res.data
    }).catch(error => {
      toaster("Failed to add link", "error")
      setLinksLoading(false);
      setOpenLinkModal(false);
    })
  }

  const confirmUpdate = (formData, linkId) => {
    setLinksLoading(true);
    if(formData.get('url') === null){
      formData.append('url', '')
    }
    if(formData.get('description') === null){
      formData.append('description', '')
    }
    if(formData.get('button_text') === null){
      formData.append('button_text', '')
    }
    return updateLink(formData, linkId).then(res => {

      // for grid on study details page
      if (linkList && setStudyDetails && res.data) {
        setStudyDetails({
          type: 'UPDATE_ITEM',
          itemType: 'links',
          item: res.data,
        })
      }

      // for link list page
      setRefreshData(true)

      setLinksLoading(false);
      toaster("Link updated successfully", "success")
      setOpenLinkModal(false)
      return res.data
    }).catch(error => {
      setLinksLoading(false);
      toaster("Failed to update link", "error")
      setOpenLinkModal(false)
    });
  }

  const confirmDelete = () => {
    setLinksLoading(true)
    deleteLink(deleteItem.id).then(res => {

      // for grid on study details page
      if (linkList && setStudyDetails) {
        setStudyDetails({
          type: 'DELETE_ITEM',
          itemType: 'links',
          id: deleteItem.id,
        })
      }

      // for link list page
      setRefreshData(true) // setRefreshData(true)

      setLinksLoading(false)
    })
    setOpenDeleteModal(false)
  }

  /** EVENT HANDLERS */

  const linkRowClicked = data => {
    setDetailModalMode("update")
    setLinkData(data)
    setLinkId(data.id)

    setOpenLinkModal(true)
  }

  /** COMPONENTS */

  const addLinksButton = () => {
    return <Button
      kind="primary"
      onClick={() => addNewLink()}
      style={addLinkBtnStyle}
      disabled={onlyAttachment === "true"}
    >Add Link</Button>
  }


  const linksSearch = () => {
    return <div style={{ width: "300px" }}>
      <Search
        size="sm"
        value={search}
        labelText="search"
        onChange={e => setSearch(e.target.value)}
        placeHolderText="Search using any data value" />
    </div>
  }

  const linkGrid = () => {
    return <>
      <LinksGrid
        // linksList={studyLink}
        search={searchGrid}
        onRowClicked={linkRowClicked}
        // onDeleteClicked={showDeleteConfirm}
        setRefresh={setRefreshData}
        refresh={refreshData}
        sort={sort}
        setSort={setSort}
        isStudyDetail={isStudyDetail}
        linksList={linkList}
        // setStudyDetails={setStudyDetails}
        // search={searchGrid}
        // onRowClicked={linkRowClicked}
        onDeleteClicked={linkRemoveRow}
        // setRefresh={setRefreshData}
        // refresh={refreshData}
        // sort={sort}
        // setSort={setSort}
        // isStudyDetail={isStudyDetail}
      />
      <LinkDetailModal
        mode={detailModalMode}
        linkId={linkId}
        open={openLinkModal}
        linkData={linkData}
        onClose={() => setOpenLinkModal(false)}
        confirmSave={confirmSave}
        confirmUpdate={confirmUpdate}
        linksLoading={linksLoading}
        setLinksLoading={setLinksLoading}
        isStudyDetail={isStudyDetail}
        studyOrgStudyId={isStudyDetail ? studyOrgStudyId : null}
        studyPgId={isStudyDetail ? studyPgId : null}
        studyListOptions={studyListOptions}
      />
      <ConfirmModal
        title="Confirmation"
        content={`Do you want to delete ${deleteItem?.url} from study ${deleteItem?.org_study_id}?`}
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        onConfirm={confirmDelete}
      />
    </>
  }

  return {
    addLinksButton,
    linkGrid,
    linksSearch,
    linksLoading,
    setLinksLoading,
  }
}

export default useLinksGrid
